import { ContainerProvider } from "../../Container/ContainerProvider/ContainerProvider";
import styles from "./DetailsFood.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var DetailsFood = function DetailsFood(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(ContainerProvider, {
    maxWidth: "820px",
    children: /*#__PURE__*/_jsx("div", {
      className: styles.details,
      children: children
    })
  });
};